module.exports = __webpack_public_path__ + "static/media/PennPres.c00651fc.png";